module.exports = __webpack_public_path__ + "media/logo/logo_datax-87a1a409.png";